<template>
    <div class="mdl-shadow--4dp">
        <div class="mdl-grid bold">
            <div class="mdl-cell mdl-cell--3-col-desktop mdl-cell--2-col-tablet mdl-cell--1-col-phone">
                Jméno
            </div>
            <div class="mdl-cell mdl-cell--3-col-desktop mdl-cell--2-col-tablet mdl-cell--1-col-phone">
                Celková částka
            </div>
            <div class="mdl-cell mdl-cell--3-col-desktop mdl-cell--2-col-tablet mdl-cell--1-col-phone">
                Zaměstnanec
            </div>
            <div class="mdl-cell mdl-cell--3-col-desktop mdl-cell--2-col-tablet mdl-cell--1-col-phone">
                Zaměstnavatel
            </div>
        </div>
        <div v-for="(userSummary, i) in summary.users" :key="userSummary.userName" class="mdl-grid"
             :class="{'even':i % 2 === 0}" style="font-size: 13px">
            <div class="mdl-cell mdl-cell--3-col-desktop mdl-cell--2-col-tablet mdl-cell--1-col-phone">
                {{ userSummary.userName }}
            </div>
            <div class="mdl-cell mdl-cell--3-col-desktop mdl-cell--2-col-tablet mdl-cell--1-col-phone">
                {{ userSummary.amount }}
            </div>
            <div class="mdl-cell mdl-cell--3-col-desktop mdl-cell--2-col-tablet mdl-cell--1-col-phone">
                {{ userSummary.paidByEmployee }}
            </div>
            <div class="mdl-cell mdl-cell--3-col-desktop mdl-cell--2-col-tablet mdl-cell--1-col-phone">
                {{ userSummary.paidByEmployer }}
            </div>
        </div>
        <div class="mdl-grid bold">
            <div class="mdl-cell mdl-cell--3-col-desktop mdl-cell--2-col-tablet mdl-cell--1-col-phone">
                Suma
            </div>
            <div class="mdl-cell mdl-cell--3-col-desktop mdl-cell--2-col-tablet mdl-cell--1-col-phone">
                {{ summary.totalSum }}
            </div>
            <div class="mdl-cell mdl-cell--3-col-desktop mdl-cell--2-col-tablet mdl-cell--1-col-phone">
                {{ summary.employeeSum }}
            </div>
            <div class="mdl-cell mdl-cell--3-col-desktop mdl-cell--2-col-tablet mdl-cell--1-col-phone">
                {{ summary.employerSum }}
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "AccountingAllUsersSummary",
        props: {
            summary: {
                type: Object,
                required: true
            }
        }
    }
</script>

<style scoped>
    .bold {
        font-weight: bold;
    }

    .even {
        background: #EEEEEE;
    }

    .mdl-cell { margin-top: 0;
        margin-bottom: 0
    }
</style>